export default __webpack_public_path__ + "static/media/folders.422b407b.svg";